export const sliceArrayByLimit = (totalPages_props, limit_props) => {
    const totalPageArray = Array(totalPages_props)
        .fill()
        .map((_, index) => index);

    return Array(Math.ceil(totalPages_props / limit_props))
        .fill()
        .map(() => totalPageArray.splice(0, limit_props));
};
